import 'foundation-sites/dist/css/foundation.min.css';
import 'foundation-sites/dist/js/foundation.min.js';

import "./Footer.css"

const Footer = () => (
    <main className="Footer">
        <section style={{backgroundColor: '#FFF'}}>
            <div>
                <div className="text-center margin-0-auto">
                    <img src="/public/credit/assets/img/footer-logo.png" alt=""/>
                </div>
            </div>
        </section>
    </main>
);

export default Footer;
